export const API_BASE_URL = process.env.VUE_APP_API_URL
export const BASE_URL = process.env.VUE_APP_BASE_URL
export const IMAGE_BASE_URL = process.env.VUE_APP_IMAGE_URL

export default undefined
